import { DOCUMENT } from '@angular/common';
import { Inject, Injectable, Renderer2 } from '@angular/core';
import { environment } from '@environments/environment';

declare global {
  interface Window {
    setupEnforcement?: (myEnforcement: any) => void;
    myEnforcement?: any;
  }
}

@Injectable({
  providedIn: 'root'
})
export class ArkoseService {
  constructor(@Inject(DOCUMENT) private document: Document) { }

  // Append the JS tag to the Document Body.
  // Returns null (and skips loading) if the environment doesn't have arkoseCompany/arkoseKey configured.
  public loadScript(
    renderer: Renderer2,
    publicKey: string,
    nonce?: string
  ): HTMLScriptElement | null {
    if (!environment.arkoseCompany || !environment.arkoseKey) {
      console.log('Arkose is not configured for this environment (missing arkoseCompany/arkoseKey). Skipping script load.');
      return null;
    }

    const scriptId = 'arkose-script';
    const currentScript = this.document.getElementById(scriptId);
    if (currentScript) {
      currentScript.remove();
    }
    const script = renderer.createElement('script');
    script.id = scriptId;
    script.type = 'text/javascript';
    script.src = `https://${environment.arkoseCompany}.comparethemarket.com/v2/${environment.arkoseKey}/api.js`;
    script.setAttribute('data-callback', 'setupEnforcement');
    if (nonce) {
      script.setAttribute('data-nonce', nonce);
    }
    renderer.appendChild(this.document.body, script);
    return script;
  }
}